<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
    font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    width: 100%;
    height: 100%;
    font-size: 12px;
  }

  /*全局样式设置*/
  .el-dialog {
    border-radius: 10px;
  }


  .el-dialog .el-dialog__header {
    border-bottom: 1px solid #F5F2F0;

  }

  .el-dialog .el-dialog__body {
    padding-top: 10px;
  }

  .el-table .el-table__cell{
     padding: 3px 0;
  }

  .title {
    position: relative;
    padding-left: 10px;
    margin-bottom: 15px;
    font-size: 14px;
    color: #333;
    font-weight: 700;
  }

  .title:before {
    content: "";
    position: absolute;
    top: 4px;
    left: 0;
    width: 5px;
    height: 65%;
    background-color: #249af3;
  }

  /*上传组件样式全局更改*/
  .el-upload-list el-upload-list--picture-card {
  	height: 96px !important;
  	width: 96px !important;
  	line-height: 96px !important;
  }

  .el-upload--picture-card {
  	height: 96px !important;
  	width: 96px !important;
  	line-height: 96px !important;
  }

  .el-upload-list__item {
  	height: 96px !important;
  	width: 96px !important;
  	line-height: 96px !important;
  }

  .el-upload-list__item-status-label i {
  	position: absolute;
  	width: 12x;
  	right: 12px;
  	top: 0px;
  }

  .el-upload--picture-card {
  	height: 96px !important;
  	width: 96px !important;
  	line-height: 96px !important;
  }

  .el-upload-list__item {
  	height: 96px !important;
  	width: 96px !important;
  	line-height: 96px !important;
  	transition: none !important;
  }

  .el-upload-list__item-status-label i {
  	position: absolute;
  	width: 12x;
  	right: 12px;
  	top: 0px;
  }

  .el-upload-list__item {
  	transition: none;
  }

  .el-form-item__label {
    color: #3a91e7;
    font-weight: bold;
  }

  .el-form-item--small.el-form-item {
    margin-bottom: 18px;
  }



</style>



// WEBPACK FOOTER //
// src/App.vue